import { render, staticRenderFns } from "./gameAll.vue?vue&type=template&id=46565212&scoped=true&"
import script from "./gameAll.vue?vue&type=script&lang=js&"
export * from "./gameAll.vue?vue&type=script&lang=js&"
import style0 from "./gameAll.vue?vue&type=style&index=0&id=46565212&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46565212",
  null
  
)

export default component.exports